module.exports = __webpack_public_path__ + "img/american express.1c1af0c0.svg";